<template>
  <div class="couponlist" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <ul>
      <li v-for="(item,i) in coupon">
        <div class="cate" @click="toPush(item.id,'coupondraw')">商家代金劵<font style="font-size:14px;padding-left:5px">({{item.num}}张)</font></div>
        <div class="con" @click="toPush(item.id,'coupondraw')">
          <h2>{{item.title}}</h2>
          <p>有效期 至 {{item.endtime}}</p>
        </div>
        <div class="price" @click="toPush(item.id,'coupondraw')">
          <h3><font>￥</font>{{item.price}}</h3>
          <p>满{{item.use}}可用</p>
        </div>
        <div class="code" @click="codes()"><a>获取二维码</a></div>
      </li>
    </ul>
    <div class="none">
      <img src="~assets/images/none.png" />
      <p>空空如也~</p>
    </div>
    <div style="height:90px"></div>
    <div class="yhj" @click="toPush(mall_id,'couponadd')">创建优惠劵</div>


     <el-dialog title="商家代金劵二维码" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
        <div class="qrcode" id="qrCode"></div>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        coupon:[],
        mall_id:0,
        dialogFormVisible:false,
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      var id = this.$route.query.id;
      this.mall_id = id
    },
    mounted() {
      this.beforeMount();
      this.listCoupon()
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      codes:function(){
        var id = this.$route.query.id;
        this.dialogFormVisible = true;
        setTimeout(function () {
          document.getElementById("qrCode").innerHTML = "";
          var qrcode = new QRCode('qrCode', {
              text: "http://user.4008005216.com/main/detail?id="+id, // 需要转换为二维码的内容
              width: 160,
              height: 160,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
          })
        }, 100);
      },

      listCoupon:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/couponList',
          params:{
            id:id
          }
        }).then(function(response){
          that.coupon = response.data.data;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }

  .el-dialog{
    width:85% !important;
  }
  .couponlist{
    max-width:640px;
    background:#ebebeb;
    margin:0 auto;
  }
  
  .couponlist ul{
    width:92%;
    display:block;
    margin:0 auto;
  }
  .couponlist ul li{
    width:100%;
    display:block;
    background:#fff;
    border-radius:10px;
    position: relative;
    margin-bottom:10px
  }
  .couponlist ul li .cate{
    position: absolute;
    top:0;
    left:0;
    background:rgba(255,30,0,0.7);
    color:#fff;
    border-radius:10px 0 10px 0;
    font-size:14px;
    padding:6px;
  }

  .couponlist ul li .con{
    width:92%;
    margin:0 auto;
    padding:40px 0 0px 0;
  }
  .couponlist ul li .con h2{
    font-size:20px;
    font-weight:normal;
    width:72%;
  }
  .couponlist ul li .con p{
    font-size:15px;
    color:#666;
    padding-top:5px
  }
  .couponlist ul li .price{
    position: absolute;
    top:40px;
    right:4%;
  }
  .couponlist ul li .price h3{
    font-size:26px;
    color:rgb(255,30,0);
    text-align:center;
  }
  .couponlist ul li .price h3 font{
    font-size:15px;
    font-weight:normal
  }
  .couponlist ul li .price p{
    color:rgb(255,30,0);
    font-size:15px;
    text-align:center;
    padding-top:2px
  }
  .couponlist .yhj{
    position: fixed;
    width:84%;
    height:45px;
    line-height:45px;
    text-align:center;
    color:#fff;
    font-size:15px;
    background: #FF751A;
    bottom:10px;
    left:8%;
    border-radius: 45px;
  }
  .couponlist .code{
    width:92%;
    margin:0 auto;
    text-align:left;
    height:50px;
    line-height:50px;
    color:#666;
    font-size:15px;
  }

  .couponlist .none{
    text-align:center;
    padding-top:120px;
    display:none;
  }
  .couponlist .none img{
    display:block;
    margin:0px auto;
    width:100px;
  }
  .couponlist .none p{
    color:#999;
    font-size:15px;
    padding-top:5px;
    letter-spacing:2px;
  }


  .qrcode {
    padding-bottom:40px;
    width: 160px;
    height: 160px;
    display:block;
    margin:0 auto;
  }
  .qrcode img{
    margin:0 auto;
    width: 160px;
    height: 160px;
    background-color: #fff; 
    padding: 6px;
  }

</style>